var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuru(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 2.2H13.1333C12.6667 0.924 11.4444 0 10 0C8.55556 0 7.33333 0.924 6.86667 2.2H2.22222C1 2.2 0 3.19 0 4.4V19.8C0 21.01 1 22 2.22222 22H17.7778C19 22 20 21.01 20 19.8V4.4C20 3.19 19 2.2 17.7778 2.2ZM10 2.2C10.6111 2.2 11.1111 2.695 11.1111 3.3C11.1111 3.905 10.6111 4.4 10 4.4C9.38889 4.4 8.88889 3.905 8.88889 3.3C8.88889 2.695 9.38889 2.2 10 2.2ZM10 6.6C11.8444 6.6 13.3333 8.074 13.3333 9.9C13.3333 11.726 11.8444 13.2 10 13.2C8.15556 13.2 6.66667 11.726 6.66667 9.9C6.66667 8.074 8.15556 6.6 10 6.6ZM16.6667 19.8H3.33333V18.26C3.33333 16.06 7.77778 14.85 10 14.85C12.2222 14.85 16.6667 16.06 16.6667 18.26V19.8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuru);
export default __webpack_public_path__ + "static/media/guru.f62cecd9e38cc71a11bfd1455c2794ed.svg";
export { ForwardRef as ReactComponent };